<div class="container">
    <div class="row">
        <div class="col-sm-9">{{config.message}}</div>
        <div class="col-sm-1 action" (click)="act(action)" *ngFor="let action of actions">{{action.title}}</div>
    </div>
</div>